@if (!isOnline) {
<div class="offline-banner">
  <ion-icon name="cloud-offline-outline"></ion-icon>
  <span>{{ 'offline.offline_msg' | transloco }}</span>
</div>
}

@if (showBackOnline) {
<div class="online-banner">
  <ion-icon name="checkmark-circle-outline"></ion-icon>
  <span>{{ 'offline.back_online' | transloco }}</span>
</div>
}
